var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddLocationInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#413892;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_5843",
    transform: "translate(1831 -3380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4454",
    transform: "translate(147 207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4452",
    transform: "translate(-3 -326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    transform: "translate(23 362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2518"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1977,3178.5c-2.8,0-5.5-0.5-8-1.6c-2.4-1-4.6-2.5-6.5-4.4c-1.9-1.9-3.4-4.1-4.4-6.5 c-1.1-2.5-1.6-5.2-1.6-8s0.5-5.5,1.6-8c1-2.4,2.5-4.6,4.4-6.5c1.9-1.9,4.1-3.4,6.5-4.4c2.5-1.1,5.2-1.6,8-1.6s5.5,0.5,8,1.6 c2.4,1,4.6,2.5,6.5,4.4c1.9,1.9,3.4,4.1,4.4,6.5c1.1,2.5,1.6,5.2,1.6,8s-0.5,5.5-1.6,8c-1,2.4-2.5,4.6-4.4,6.5 c-1.9,1.9-4.1,3.4-6.5,4.4C-1971.5,3178-1974.2,3178.5-1977,3178.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1977,3138c-2.7,0-5.3,0.5-7.8,1.6c-2.4,1-4.5,2.4-6.4,4.3c-1.8,1.8-3.3,4-4.3,6.4 c-1,2.5-1.6,5.1-1.6,7.8s0.5,5.3,1.6,7.8c1,2.4,2.4,4.5,4.3,6.4c1.8,1.8,4,3.3,6.4,4.3c2.5,1,5.1,1.6,7.8,1.6 s5.3-0.5,7.8-1.6c2.4-1,4.5-2.4,6.4-4.3c1.8-1.8,3.3-4,4.3-6.4c1-2.5,1.6-5.1,1.6-7.8s-0.5-5.3-1.6-7.8 c-1-2.4-2.4-4.5-4.3-6.4c-1.8-1.8-4-3.3-6.4-4.3C-1971.7,3138.5-1974.3,3138-1977,3138 M-1977,3137c11.6,0,21,9.4,21,21 s-9.4,21-21,21s-21-9.4-21-21S-1988.6,3137-1977,3137z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4491-2",
    transform: "translate(49.299 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2589",
    transform: "translate(-49.299 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.7,10c-4.8,0.2-8.6,4.2-8.5,9.1c0,0.5,0.1,0.9,0.2,1.3l0,0c0,0,0,0.1,0.1,0.3c0.1,0.6,0.3,1.2,0.6,1.7 c0.9,2.1,2.9,5.6,7.5,9.4c0.3,0.2,0.7,0.2,1,0c4.6-3.8,6.6-7.3,7.5-9.4c0.3-0.6,0.5-1.1,0.6-1.7c0-0.2,0.1-0.3,0.1-0.3l0,0 c0.9-4.8-2.2-9.4-7-10.3C22,10,21.3,10,20.7,10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,11L21,11c-0.1,0-0.2,0-0.3,0c-1.9,0.1-3.7,0.8-5,2.1c-1.4,1.3-2.2,3-2.4,4.9c-0.1,0.7,0,1.5,0.1,2.2 l0,0l0,0c0,0,0,0.1,0,0.2l0,0l0,0c0.1,0.5,0.3,1,0.5,1.5l0,0l0,0c0.9,2.1,2.8,5.3,7,8.9c4.2-3.5,6.2-6.8,7-8.9l0,0l0,0 c0.2-0.5,0.4-1,0.5-1.5l0,0l0,0c0-0.1,0-0.2,0-0.2s0,0,0,0l0,0l0,0c0.1-0.5,0.1-1,0.1-1.5C28.8,14.5,25.3,11,21,11 M21,10 c4.8,0,8.8,3.9,8.8,8.8c0,0.6-0.1,1.1-0.2,1.7c0,0,0,0.1-0.1,0.3c-0.1,0.6-0.3,1.2-0.6,1.7c-0.9,2.1-2.9,5.6-7.5,9.4 C21.3,31.9,21.2,32,21,32s-0.3-0.1-0.5-0.2c-4.6-3.8-6.6-7.3-7.5-9.4c-0.3-0.6-0.5-1.1-0.6-1.7c0-0.2-0.1-0.3-0.1-0.3 c-0.2-0.8-0.2-1.7-0.1-2.5c0.4-4.4,4.1-7.8,8.4-7.9C20.8,10,20.9,10,21,10z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.9,18.4 21.5,18.4 21.5,15 20.5,15 20.5,18.4 17.1,18.4 17.1,19.4 20.5,19.4 20.5,22.8 21.5,22.8  21.5,19.4 24.9,19.4  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddLocationInfo);
export default __webpack_public_path__ + "static/media/icon_add_location_info.28ece749d3bf28d12bd7a50ebae8fd3b.svg";
export { ForwardRef as ReactComponent };